<template>
  <div class="devops-page">
    <!-- Main Content -->
    <main>
      <!-- DevOps Overview Section -->
      <section class="overview-section">
        <div class="container">
          <div class="row align-items-center">
            <div class="col-lg-6">
              <div class="section-content">
                <span class="subtitle">DevOps Transformation</span>
                <h2>Continuous <span class="text-gradient">Delivery</span> und Automatisierung</h2>
                <div class="feature-icon mb-4">
                  <svg xmlns="http://www.w3.org/2000/svg" width="40" height="40" viewBox="0 0 640 512">
                    <path fill="#1DAAE4" d="M0 241.1C0 161 65 96 145.1 96c38.5 0 75.4 15.3 102.6 42.5L320 210.7l72.2-72.2C419.5 111.3 456.4 96 494.9 96C575 96 640 161 640 241.1v29.7C640 351 575 416 494.9 416c-38.5 0-75.4-15.3-102.6-42.5L320 301.3l-72.2 72.2C220.5 400.7 183.6 416 145.1 416C65 416 0 351 0 270.9V241.1zM274.7 256l-72.2-72.2c-15.2-15.2-35.9-23.8-57.4-23.8C100.3 160 64 196.3 64 241.1v29.7c0 44.8 36.3 81.1 81.1 81.1c21.5 0 42.2-8.5 57.4-23.8L274.7 256zm90.5 0l72.2 72.2c15.2 15.2 35.9 23.8 57.4 23.8c44.8 0 81.1-36.3 81.1-81.1V241.1c0-44.8-36.3-81.1-81.1-81.1c-21.5 0-42.2 8.5-57.4 23.8L365.3 256z"/>
                  </svg>
                </div>
                <p>DevOps verbindet Menschen, Prozesse und Technologien, um kontinuierliche Wertschöpfung für Ihre Kunden zu ermöglichen. Es geht nicht nur um Tools, sondern um eine Kultur der Zusammenarbeit zwischen Entwicklung und Betrieb.</p>
                <p>Mit unserer DevOps-Transformation beschleunigen wir Ihre Entwicklungszyklen durch automatisierte CI/CD-Pipelines, Container-Technologien und Infrastructure as Code. Das Ergebnis: Schnellere Markteinführung, höhere Qualität und mehr Innovation.</p>
                <div class="stats-container">
                  <div class="stat-item">
                    <span class="stat-number">70%</span>
                    <span class="stat-text">Schnellere Releases</span>
                  </div>
                  <div class="stat-item">
                    <span class="stat-number">80%</span>
                    <span class="stat-text">Weniger Fehler</span>
                  </div>
                  <div class="stat-item">
                    <span class="stat-number">60%</span>
                    <span class="stat-text">Kosteneinsparung</span>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-lg-6">
              <div class="image-container">
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 640 512" class="img-fluid" width="100%" height="300">
                  <path fill="#1DAAE4" d="M320 104.5c171.4 0 303.2 72.2 303.2 151.5S491.3 407.5 320 407.5c-171.4 0-303.2-72.2-303.2-151.5S148.7 104.5 320 104.5m0-16.8C143.3 87.7 0 163.8 0 256s143.3 168.3 320 168.3S640 348.2 640 256S496.7 87.7 320 87.7zM218.2 242.5c-7.9 40.5-35.8 36.3-70.1 36.3l13.7-70.6c38 0 63.8-4.1 56.4 34.3zM97.4 350.3h36.7l8.7-44.8c41.1 0 66.6 3 90.2-19.1 26.1-24 32.9-66.7 14.3-88.1-9.7-11.2-25.3-16.7-46.5-16.7h-70.7L97.4 350.3zm185.7-213.6h36.5l-8.7 44.8c31.5 0 60.7-2.3 74.8 10.7 14.8 13.6 7.7 31-8.3 113.1h-37c15.4-79.4 18.3-86 12.7-92-5.4-5.8-17.7-4.6-47.4-4.6l-18.8 96.6h-36.5l32.7-168.6zM505 242.5c-8 41.1-36.7 36.3-70.1 36.3l13.7-70.6c38.2 0 63.8-4.1 56.4 34.3zM384.2 350.3H421l8.7-44.8c43.2 0 67.1 2.5 90.2-19.1 26.1-24 32.9-66.7 14.3-88.1-9.7-11.2-25.3-16.7-46.5-16.7H417l-32.8 168.7z"/>
                </svg>
              </div>
            </div>
          </div>
        </div>
      </section>

      <!-- DevOps Benefits Section -->
      <section class="benefits-section">
        <div class="container">
          <div class="section-title text-center">
            <span class="subtitle">Ihre Vorteile</span>
            <h2>Warum Sie auf <span class="text-gradient">DevOps</span> setzen sollten</h2>
          </div>
          
          <div class="row mt-5">
            <div class="col-md-4 mb-4">
              <div class="benefit-card">
                <div class="benefit-icon">
                  <svg xmlns="http://www.w3.org/2000/svg" width="40" height="40" viewBox="0 0 512 512">
                    <path fill="#1DAAE4" d="M234.5 5.7c13.9-5 29.1-5 43.1 0l192 68.6C495 83.4 512 107.5 512 134.6V377.4c0 27-17 51.2-42.5 60.3l-192 68.6c-13.9 5-29.1 5-43.1 0l-192-68.6C17 428.6 0 404.5 0 377.4V134.6c0-27 17-51.2 42.5-60.3l192-68.6zM256 66L82.3 128 256 190l173.7-62L256 66zm32 368.6l160-57.1v-188L288 246.6v188z"/>
                  </svg>
                </div>
                <h3>Schnellere Markteinführung</h3>
                <p>Durch automatisierte Prozesse und kürzere Feedback-Zyklen bringen Sie Ihre Produkte schneller und zuverlässiger auf den Markt.</p>
                <ul class="benefit-features">
                  <li>Verkürzte Time-to-Market</li>
                  <li>Kontinuierliche Integration und Delivery</li>
                  <li>Schnelles Feedback zu neuen Features</li>
                </ul>
              </div>
            </div>
            
            <div class="col-md-4 mb-4">
              <div class="benefit-card">
                <div class="benefit-icon">
                  <svg xmlns="http://www.w3.org/2000/svg" width="40" height="40" viewBox="0 0 512 512">
                    <path fill="#1DAAE4" d="M128 0C92.7 0 64 28.7 64 64v96h64V64H354.7L384 93.3V160h64V93.3c0-17-6.7-33.3-18.7-45.3L400 18.7C388 6.7 371.7 0 354.7 0H128zM384 352v32 64H128V384 368 352H384zm64 32h32c17.7 0 32-14.3 32-32V256c0-35.3-28.7-64-64-64H64c-35.3 0-64 28.7-64 64v96c0 17.7 14.3 32 32 32H64v64c0 35.3 28.7 64 64 64H384c35.3 0 64-28.7 64-64V384zM432 248a24 24 0 1 1 0 48 24 24 0 1 1 0-48z"/>
                  </svg>
                </div>
                <h3>Höhere Zuverlässigkeit</h3>
                <p>Verbessern Sie die Stabilität und Verfügbarkeit Ihrer Systeme durch Infrastructure as Code und automatisierte Tests.</p>
                <ul class="benefit-features">
                  <li>Reproduzierbare Infrastruktur</li>
                  <li>Konsistente Umgebungen</li>
                  <li>Automatisierte Rollbacks</li>
                </ul>
              </div>
            </div>
            
            <div class="col-md-4 mb-4">
              <div class="benefit-card">
                <div class="benefit-icon">
                  <svg xmlns="http://www.w3.org/2000/svg" width="40" height="40" viewBox="0 0 512 512">
                    <path fill="#1DAAE4" d="M32 32c17.7 0 32 14.3 32 32V400c0 8.8 7.2 16 16 16H480c17.7 0 32 14.3 32 32s-14.3 32-32 32H80c-44.2 0-80-35.8-80-80V64c0-17.7 14.3-32 32-32zm96 96c0-17.7 14.3-32 32-32H480c17.7 0 32 14.3 32 32s-14.3 32-32 32H160c-17.7 0-32-14.3-32-32zm64 64c0-17.7 14.3-32 32-32H480c17.7 0 32 14.3 32 32s-14.3 32-32 32H224c-17.7 0-32-14.3-32-32zm32 96c-17.7 0-32-14.3-32-32s14.3-32 32-32H480c17.7 0 32 14.3 32 32s-14.3 32-32 32H224z"/>
                  </svg>
                </div>
                <h3>Bessere Skalierbarkeit</h3>
                <p>Nutzen Sie Cloud-native Technologien wie Kubernetes, um Ihre Anwendungen elastisch und kosteneffizient zu skalieren.</p>
                <ul class="benefit-features">
                  <li>Automatische Skalierung</li>
                  <li>Lastenverteilung</li>
                  <li>Ressourcenoptimierung</li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </section>

      <!-- DevOps Maturity Assessment Section -->
      <section class="assessment-section">
        <div class="container">
          <div class="row align-items-center">
            <div class="col-lg-6">
              <div class="assessment-content">
                <span class="subtitle">Maßgeschneiderte Analyse</span>
                <h2>DevOps-Reife-<span class="text-gradient">Assessment</span></h2>
                <div class="feature-icon mb-4">
                  <svg xmlns="http://www.w3.org/2000/svg" width="40" height="40" viewBox="0 0 512 512">
                    <path fill="#1DAAE4" d="M64 64c0-17.7 14.3-32 32-32h320c17.7 0 32 14.3 32 32s-14.3 32-32 32H96c-17.7 0-32-14.3-32-32zM224 160c0-17.7 14.3-32 32-32h160c17.7 0 32 14.3 32 32s-14.3 32-32 32H256c-17.7 0-32-14.3-32-32zM160 256c0-17.7 14.3-32 32-32h160c17.7 0 32 14.3 32 32s-14.3 32-32 32H192c-17.7 0-32-14.3-32-32zM288 352c0-17.7 14.3-32 32-32h32c17.7 0 32 14.3 32 32s-14.3 32-32 32H320c-17.7 0-32-14.3-32-32zM80 352a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zm112 0a24 24 0 1 1 48 0 24 24 0 1 1 -48 0z"/>
                  </svg>
                </div>
                <p>Erhalten Sie einen umfassenden Einblick in den aktuellen Stand Ihrer DevOps-Praktiken und identifizieren Sie Verbesserungspotenziale. Unser maßgeschneidertes Assessment deckt folgende Bereiche ab:</p>
                <ul class="assessment-areas">
                  <li>Automatisierungsgrad Ihrer Entwicklungs- und Deployment-Prozesse</li>
                  <li>CI/CD-Pipeline-Reife und -Effizienz</li>
                  <li>Infrastruktur-Management-Praktiken</li>
                  <li>Monitoring- und Observability-Fähigkeiten</li>
                  <li>DevSecOps-Integration und Sicherheitsmaßnahmen</li>
                  <li>Team-Kultur und Zusammenarbeit</li>
                </ul>
                <button class="btn-primary mt-4">Ihre persönliche Analyse buchen</button>
              </div>
            </div>
            <div class="col-lg-6">
              <div class="assessment-image">
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 640 512" class="img-fluid assessment-illustration">
                  <path fill="#1DAAE4" d="M0 192c0-35.3 28.7-64 64-64h512c35.3 0 64 28.7 64 64v128c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V192zm48 16c0 8.8 7.2 16 16 16h16c8.8 0 16-7.2 16-16s-7.2-16-16-16H64c-8.8 0-16 7.2-16 16zm368-16c-8.8 0-16 7.2-16 16s7.2 16 16 16h64c8.8 0 16-7.2 16-16s-7.2-16-16-16H416zM48 288c0 8.8 7.2 16 16 16h176c8.8 0 16-7.2 16-16s-7.2-16-16-16H64c-8.8 0-16 7.2-16 16zm368-16c-8.8 0-16 7.2-16 16s7.2 16 16 16h64c8.8 0 16-7.2 16-16s-7.2-16-16-16H416z"/>
                  <path fill="#1DAAE4" d="M312 144c13.3 0 24 10.7 24 24v16c0 13.3-10.7 24-24 24s-24-10.7-24-24V168c0-13.3 10.7-24 24-24zm-24 96c0-13.3 10.7-24 24-24s24 10.7 24 24v16c0 13.3-10.7 24-24 24s-24-10.7-24-24V240z"/>
                </svg>
              </div>
            </div>
          </div>
        </div>
      </section>

      <!-- Integrated Components Section -->
      <section class="integrated-components-section">
        <div class="container">
          <div class="section-title text-center">
            <span class="subtitle">Ganzheitlicher Ansatz</span>
            <h2>DevOps und <span class="text-gradient">KI</span> vereint</h2>
            <p class="lead">Erfahren Sie mehr über unsere integrierten Lösungen auf der Startseite</p>
          </div>
          
          <div class="cta-buttons animated fadeInUp mt-5 text-center">
            <a href="/#services" class="btn-primary mx-2">Zu unseren Leistungen</a>
            <a href="/#erfolgsgeschichten" class="btn-secondary mx-2">Erfolgsgeschichten anschauen</a>
            <a href="/#referenzen" class="btn-outline mx-2">Kundenstimmen hören</a>
          </div>
        </div>
      </section>

      <!-- CTA Section -->
      <section class="cta-section">
        <div class="container text-center">
          <h2>Beginnen Sie Ihre DevOps-Transformation</h2>
          <p>Kontaktieren Sie uns für ein unverbindliches Erstgespräch zu Ihren DevOps-Anforderungen.</p>
          <a href="/#kontakt" class="btn-primary">Beratungsgespräch vereinbaren</a>
        </div>
      </section>
    </main>
  </div>
</template>

<script>
export default {
  name: 'AppDevOps'
}
</script>

<style lang="scss" scoped>
@import "@/assets/css/global.scss";

.devops-page {
  overflow-x: hidden;
}

.overview-section {
  background: linear-gradient(180deg, darken($background-color, 3%), $background-color);
  padding: 100px 0;
}

.section-content {
  .subtitle {
    display: inline-block;
    color: $accent-color;
    font-weight: 600;
    margin-bottom: 15px;
    font-size: 1.1rem;
    position: relative;
    padding-left: 15px;
    
    &::before {
      content: '';
      position: absolute;
      left: 0;
      top: 50%;
      transform: translateY(-50%);
      width: 5px;
      height: 20px;
      background: $accent-gradient;
      border-radius: 3px;
    }
  }
  
  h2 {
    font-size: 2.5rem;
    margin-bottom: 20px;
    color: $heading-color;
  }
  
  p {
    color: $muted-text-color;
    margin-bottom: 20px;
    font-size: 1.1rem;
    line-height: 1.6;
  }
}

.stats-container {
  display: flex;
  justify-content: space-between;
  margin-top: 40px;
  
  .stat-item {
    text-align: center;
    
    .stat-number {
      display: block;
      font-size: 2.5rem;
      font-weight: 700;
      color: $accent-color;
      margin-bottom: 5px;
    }
    
    .stat-text {
      color: $muted-text-color;
      font-size: 0.9rem;
    }
  }
}

.image-container {
  position: relative;
  
  svg {
    filter: drop-shadow(0 10px 20px rgba(0, 0, 0, 0.3));
  }
  
  &::before {
    content: '';
    position: absolute;
    width: 120%;
    height: 120%;
    top: -10%;
    left: -10%;
    background: radial-gradient(circle at center, rgba($accent-color, 0.1), transparent 70%);
    z-index: -1;
  }
}

// Benefits Section
.benefits-section {
  padding: 100px 0;
  background: linear-gradient(0deg, rgba($accent-color, 0.03), rgba($primary-color, 0.1));
}

.benefit-card {
  background: rgba($secondary-color, 0.4);
  border-radius: 15px;
  padding: 30px;
  height: 100%;
  transition: all 0.3s ease;
  backdrop-filter: blur(5px);
  border: 1px solid rgba($accent-color, 0.1);
  
  &:hover {
    transform: translateY(-10px);
    box-shadow: 0 15px 30px rgba(0, 0, 0, 0.15);
    border-color: rgba($accent-color, 0.3);
  }
  
  .benefit-icon {
    width: 80px;
    height: 80px;
    display: flex;
    align-items: center;
    justify-content: center;
    margin: 0 auto 25px;
    background: linear-gradient(135deg, rgba($accent-color, 0.1), rgba($accent-color, 0.05));
    border-radius: 50%;
    
    svg {
      filter: drop-shadow(0 4px 6px rgba($accent-color, 0.2));
    }
  }
  
  h3 {
    font-size: 1.4rem;
    color: $accent-color;
    margin-bottom: 15px;
    text-align: center;
  }
  
  p {
    color: $muted-text-color;
    text-align: center;
    margin-bottom: 20px;
  }
}

.benefit-features {
  list-style: none;
  padding-left: 0;
  
  li {
    padding: 8px 0;
    position: relative;
    padding-left: 25px;
    color: $text-color;
    
    &::before {
      content: '✓';
      position: absolute;
      left: 0;
      color: $accent-color;
    }
  }
}

// Assessment Section
.assessment-section {
  padding: 100px 0;
  background: linear-gradient(180deg, $background-color, darken($background-color, 3%));
}

.assessment-content {
  .subtitle {
    display: inline-block;
    color: $accent-color;
    font-weight: 600;
    margin-bottom: 15px;
    font-size: 1.1rem;
  }
  
  h2 {
    font-size: 2.5rem;
    margin-bottom: 20px;
    color: $heading-color;
  }
  
  p {
    color: $muted-text-color;
    margin-bottom: 20px;
    font-size: 1.1rem;
    line-height: 1.6;
  }
}

.assessment-areas {
  list-style: none;
  padding-left: 0;
  margin-bottom: 30px;
  
  li {
    padding: 10px 0;
    position: relative;
    padding-left: 30px;
    color: $text-color;
    
    &::before {
      content: '→';
      position: absolute;
      left: 0;
      color: $accent-color;
      font-weight: bold;
    }
  }
}

.assessment-image {
  svg {
    filter: drop-shadow(0 10px 20px rgba(0, 0, 0, 0.2));
  }
}

// Integrated Components Section
.integrated-components-section {
  padding: 100px 0;
  background: linear-gradient(0deg, rgba($accent-color, 0.03), rgba($primary-color, 0.1));
  
  .lead {
    color: $muted-text-color;
    max-width: 700px;
    margin: 0 auto;
    font-size: 1.1rem;
  }
}

.btn-outline {
  background: transparent;
  color: $accent-color;
  border: 2px solid $accent-color;
  padding: 12px 28px;
  border-radius: 8px;
  cursor: pointer;
  font-weight: 600;
  letter-spacing: 0.5px;
  text-transform: uppercase;
  font-size: 0.875rem;
  transition: all 0.3s ease;
  text-decoration: none;
  
  &:hover {
    background: rgba($accent-color, 0.1);
    transform: translateY(-3px);
  }
}

// CTA Section
.cta-section {
  background: $primary-color;
  padding: 80px 0;
  position: relative;
  overflow: hidden;
  
  &::before {
    content: '';
    position: absolute;
    top: -50%;
    left: -50%;
    width: 200%;
    height: 200%;
    background: radial-gradient(circle at center, rgba($accent-color, 0.1), transparent 70%);
    z-index: 0;
  }
  
  h2 {
    color: white;
    margin-bottom: 20px;
    position: relative;
    z-index: 1;
  }
  
  p {
    color: $muted-text-color;
    max-width: 600px;
    margin: 0 auto 30px;
    position: relative;
    z-index: 1;
  }
}

// Responsive styles
@media (max-width: 992px) {
  .stats-container {
    flex-direction: column;
    
    .stat-item {
      margin-bottom: 20px;
    }
  }
  
  .assessment-image {
    margin-top: 50px;
  }
}

@media (max-width: 768px) {
  .section-content h2 {
    font-size: 2rem;
  }
  
  .benefit-card {
    margin-bottom: 30px;
  }
}

.mx-2 {
  margin-left: 0.5rem;
  margin-right: 0.5rem;
}
</style>